exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thin-vertical .ekko-lightbox .modal-header[data-v-a55cade0],.thin-vertical .ekko-lightbox[data-v-a55cade0]{padding:3px}.ekko-lightbox[data-v-a55cade0]{overflow:scroll}.ekko-lightbox .modal-dialog .modal-container .container[data-v-a55cade0]{height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a55cade0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EcomCore/Components/Common/PopupModel.vue
// module id = 38
// module chunks = 0